module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVEhL7ZFBCoJQFEXFqbQCaRW2jqB1NGgbQcto0DbElpFbCOcK/u6zQxIq/sSBgQcu///37n1PKlgUzrnQxHM+6rqOpKP0QHaPaE9HQ2J98VnnU+cX1KwXY/dHwUTBq1Q204TumXRAGWWrl9JV14R4PzKEMu51phY09K6km7TD9sFq9CrsRqq3zej+T2rkb08zuJAu0pb2IObBWxC3fE67hZ41T9KGsjeWsSxjHOUW6t3GjzBmfAFPb4gtcAHPBv3GdxPPBmzzLOgD2/QFvhBbFwxDbF0wDLHxBXPB2Bbqs8HYvycIXnqoKms0t7AkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-depot/light/24.png
// module id = 1978
// module chunks = 2